"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var primitives_1 = require("../../primitives");
exports.default = {
    fontSize: primitives_1.fontSize,
    body: primitives_1.fontFamily.inter,
    heading: primitives_1.fontFamily.inter,
};
